import { MModalFooterProps } from '../../molecules/MModalFooter/MModalFooter.types';
import { MModalHeaderProps } from '../../molecules/MModalHeader/MModalHeader.types';

export enum OModalType {
  Dialog = 'Dialog',
  Task = 'Task',
}

export interface OModalProps {
  type?: 'Dialog' | 'Task';
  scrolling?: boolean;
  footer?: boolean;
  mModalHeader?: MModalHeaderProps;
  mModalFooter?: MModalFooterProps;
  pagePath?: string;
  itemPath?: string;
  cqPath?: string;
  className?: string;
  trackingProperties?: Record<string, unknown>;
}
